/**
 * :: USAGE ::
 *
 * "subPath" is NOT expected to use on component level since it is not a full path
 * "path" is expected to use for page navigation on component level if there is no additional param to resolve
 * "pathResolver" is expected to use when the url needs to combine with some additional params
 * "canonicalPathResolver" is expected for SEO indexed page only
 * "alternatePaths" is expected to use as possible alternate path options for the page
 *
 */

export const baseUrl: { [key: string]: string } = {};

const paths = {
  top: {
    path: '/',
    pathResolver: () => `/`,
    canonicalPathResolver: () => `/`,
  },
  bonusProgram: {
    path: '/promotions/bonusprogrampickup',
    pathResolver: () => `/promotions/bonusprogrampickup`,
    canonicalPathResolver: () => `/promotions/bonusprogrampickup`,
  },
  datedAd: {
    path: '/promotions/dated-ad',
    pathResolver: () => `/promotions/dated-ad`,
    canonicalPathResolver: () => `/promotions/dated-ad`,
  },
};

export default paths;
